import React, { useState, useEffect } from 'react'
import { useNavigate, Link, useLocation } from 'react-router-dom'
import "react-datepicker/dist/react-datepicker.css";
import Cookies from 'js-cookie';

import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Table } from "antd";
import { adminMainUrl } from '../../../../Config';
import { getAllApprovedCustomers, getCompanyBranch, getJobOrderEmployeeList, getUnusedFinalQuotationWithPaginationList, getUnusedQuotationList } from '../../../../Redux/action/Joborder/JoborderAction';
import Beatloader from '../../../../Common/Loaders/Beatloader';
import axios from 'axios';
import Swal from 'sweetalert2';
import ReactPaginate from 'react-paginate';
import { useFormik } from 'formik';
import AddJobOrderByQuotationOffcanvas from './AddJobOrderByQuotationOffcanvas';
import AddJobOrderByQuotationOffcanvas3 from './AddJobOrderByQuotationOffcanvas3';

const FinalQuotationList = ({ title, accessedModules, accessedPermission }) => {

    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const [showLoader, setshowLoader] = useState(false);

    const token = Cookies.get('token');
    const user_id = Cookies.get('flexichain_user_id');
    const urlString = window.location.href;
    const url = new URL(urlString);
    const path = url.pathname.slice(1);
    const searchParams = url.search;
    const q = path + searchParams;
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const queryParams = new URLSearchParams(location.search);


    const [show, setShow] = useState(false);

    const [quotation_id, setQuotation_id] = useState("");
    const [quotation_no, setQutoation_no] = useState("");
    const [companyName, setCompanyName] = useState("");
    const [company_id, setCompany_id] = useState("");
    const [trans_mode, setTransMode] = useState(false);
    const [trans_type, setTransType] = useState(false);


    const [quoteOptionArr, setQuoteOptionArr] = useState([]);
    const [quotationOption, setQuotationOptions] = useState([]);
    const [employeeOptions, setEmployeeOptions] = useState([]);
    const [loadingEmployee, setLoadingEmployee] = useState([]);
    const [branchOption, setBranchOption] = useState([]);
    const [disableQuotationField, setDisableQuotationField] = useState(false);
    let [disableTransportMode, setDisableTransportMode] = useState(false);
    let [disableTransportType, setDisableTransportType] = useState(false);

    const [loadingQuotation, setLoadingQuotation] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = (quotation_id, quotation_no, company_name, company_id, trans_mode, trans_type) => {
        if (quotation_id) {
            setQuotation_id(quotation_id);
        } else {
            toast.error("Quotation not found.");
            return;
        }
        if (quotation_no) {
            setQutoation_no(quotation_no);
        } else {
            toast.error("Quotation no. not found.");
            return;
        }
        if (company_name) {
            setCompanyName(company_name);
        } else {
            toast.error("Company name not found.");
            return;
        }
        if (company_id) {
            setCompany_id(company_id);
        } else {
            toast.error("Company not found.");
            return;
        }
        if (trans_mode) {
            setTransMode(trans_mode);
        } else {
            toast.error("Transport mode not found.");
            return;
        }
        if (trans_type) {
            setTransType(trans_type);
        } else {
            toast.error("Transport type not found.");
            return;
        }
        setShow(true);
    };


    useEffect(() => {
        if (token && user_id) {
            dispatch(getUnusedQuotationList(token, user_id));
            dispatch(getJobOrderEmployeeList(token, user_id));
            dispatch(getAllApprovedCustomers(token, user_id));
            dispatch(getUnusedFinalQuotationWithPaginationList(token, user_id, queryParams.get("page") ?? 1, queryParams.get('search')));
        } else {
            toast.error("Please login to continue.");
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        }
    }, [token, user_id, location.pathname, location.search]);


    const refresh = () => {
        if (token && user_id) {
            dispatch(getUnusedFinalQuotationWithPaginationList(token, user_id, queryParams.get("page") ?? 1, queryParams.get('search')));
        }
    }

    useEffect(() => {

        //refresh component automatically after 60 seconds.
        const intervalId = setInterval(() => {
            refresh();
        }, 60000);

        return () => clearInterval(intervalId);
    }, [])



    // useEffect(() => {
    //     if (token, user_id, country_id) {
    //         dispatch(getUnusedFinalQuotationWithPaginationList(token, user_id, country_id))
    //     }
    // }, [country_id])



    const [branch_company_id, set_Branch_company_id] = useState("");

    useEffect(() => {
        if (branch_company_id) {
            dispatch(getCompanyBranch(token, user_id, branch_company_id));
        }
    }, [branch_company_id])

    const {
        loadingUnusedFinalQuotationWithPaginationList,
        UnusedFinalQuotationWithPaginationList,
        UnusedFinalQuotationWithPaginationListError,
        UnusedFinalQuotationWithPaginationListCurrentPage,
        UnusedFinalQuotationWithPaginationListTotalPage,
        UnusedFinalQuotationWithPaginationListTotalData,

        loadingUnusedQuotationList,
        UnusedQuotationListError,
        UnusedQuotationList,

        loadingJobOrderEmployeeList,
        JobOrderEmployeeListError,
        JobOrderEmployeeList,

        loadingJobOrderApprovedCustomerList,
        JobOrderApprovedCustomerList,
        JobOrderApprovedCustomerListError,

        loadingJobOrderCompanyBranchList,
        JobOrderCompanyBranchList,
        JobOrderCompanyBranchListError
    } = useSelector(state => state?.JoborderReducer);


    useEffect(() => {
        if (JobOrderCompanyBranchList) {
            let arr = [];
            JobOrderCompanyBranchList.map(v => { arr.push({ value: v.id, label: v.branch_name }) });
            setBranchOption(arr);
        }
    }, [JobOrderCompanyBranchList])

    useEffect(() => {
        if (loadingJobOrderEmployeeList) {
            setLoadingEmployee(true);
        } else {
            setLoadingEmployee(false);
        }

        if (JobOrderEmployeeList) {
            let arr = [];
            JobOrderEmployeeList.map(val => { arr.push({ value: val.user_id, label: val.name }) });
            setEmployeeOptions(arr);
        }
    }, [loadingJobOrderEmployeeList, JobOrderEmployeeListError, JobOrderEmployeeList]);

    useEffect(() => {
        if (loadingUnusedQuotationList) {
            setLoadingQuotation(true);
        } else {
            setLoadingQuotation(false);
        }

        if (UnusedQuotationList) {
            let arr = [];
            UnusedQuotationList.map((val) => {
                const customerName = val.customer_data && val.customer_data.name ? `(${val.customer_data.name})` : "";
                const label = `${val.ship_quotation_no} ${customerName}`;

                const trans_mode = val.transport_mode;
                const trans_type = val.transport_type;
                arr.push({ value: val.id, label, trans_mode, trans_type });
            });
            setQuoteOptionArr(arr);
            setQuotationOptions(arr);
        };

    }, [loadingUnusedQuotationList, UnusedQuotationListError, UnusedQuotationList]);

    const handleChangeCompanyBranch = (quotation_id) => {
        try {
            // formik.setFieldValue("customer_id", "");
            // formik.setFieldValue('branch_id', "");
            let config = { headers: { 'auth-token': token, 'user_id': user_id } };
            axios.get(`${adminMainUrl}/api/jobOrder/get-companydetails-on-quotation?quotation_id=${quotation_id}`, config)
                .then(response => {
                    if (response.status == 200) {
                        if (response.data) {
                            if (response.data.data) {
                                if (response.data.data.customer_data) {
                                    // formik.setFieldValue('customer_id', response.data.data.customer_data.id);
                                    setCompany_id(response.data.data.customer_data.id)
                                    setCompanyName(`${response.data.data.customer_data?.name} ${response.data.data.customer_data?.alias ? `(${response.data.data.customer_data?.alias})` : ""} - ${response.data.data.customer_data?.customerType}`);
                                    if (response.data.data.customer_data?.customer_branch) {
                                        if (Array.isArray(response.data.data.customer_data?.customer_branch)) {
                                            let arr = [];
                                            response.data.data.customer_data?.customer_branch.map(val => arr.push({ value: val.id, label: val.branch_name }));
                                            setBranchOption(arr);
                                        } else {
                                            setBranchOption([]);
                                        }
                                    } else {
                                        setBranchOption([]);
                                    }
                                } else {
                                    setCompanyName("");
                                    setCompany_id("");
                                    formik.setFieldValue('customer_id', "");
                                    setBranchOption([]);
                                }
                            }
                        }
                    } else {
                        console.log(response.data.msg);
                    }
                }).catch(err => {
                    console.log(err);
                })
        } catch (error) {
            // toast.error(error.message);
            console.log(error.message);
        }
    };

    useEffect(() => {
        if (quotation_id) {
            // console.log("Quotationid",quotation_id);
            setQuotationOptions(quoteOptionArr);
            if (quotation_id) {
                setDisableQuotationField(true);
                let findQIDQuotation = quoteOptionArr.find(v => v.value == quotation_id);
                if (findQIDQuotation) {
                    // console.log("findIDQuotation",findQIDQuotation);
                    setDisableTransportMode(true);
                    setDisableTransportType(true);
                    setTransMode(findQIDQuotation.trans_mode);
                    setTransType(findQIDQuotation.trans_type);
                }
                handleChangeCompanyBranch(Number(quotation_id));
            } else {
                setDisableQuotationField(false);
                setDisableTransportMode(false);
                setDisableTransportType(false);
            }
        } else {
            setDisableQuotationField(false);
            setDisableTransportMode(false);
            setDisableTransportType(false);
        }
    }, [quotation_id, quoteOptionArr]);

    const [dataSource, setDataSource] = useState([]);
    const columns = [
        { title: "S. No.", dataIndex: "SNo", key: "SNo" },
        { title: "Quotation No.", dataIndex: "quotation_no", key: "quotation_no" },
        { title: "Customer Name", dataIndex: "customer_name", key: "customer_name" },
        { title: "Transport Mode", dataIndex: "trans_mode", key: "trans_mode" },
        { title: "Transport Type", dataIndex: "trans_type", key: "trans_type" },
        // { title: "Status", dataIndex: "status", key: "status" },
        { title: "Action", dataIndex: "action", key: "action" },
    ];

    useEffect(() => {
        if (loadingUnusedFinalQuotationWithPaginationList) {
            setshowLoader(true);
        } else {
            setshowLoader(false);
        }
        // console.log("UnusedFinalQuotationWithPaginationList", UnusedFinalQuotationWithPaginationList);

        if (UnusedFinalQuotationWithPaginationList) {
            let arr = [];
            UnusedFinalQuotationWithPaginationList.map((val, i) => {
                arr.push({
                    key: i, // Add a unique key for each row
                    SNo: (queryParams.get("page") ? Number(queryParams.get("page")) - 1 : 0) * 10 + i + 1,
                    quotation_no: val.ship_quotation_no, // Ensure date formatting as neede
                    customer_name: val?.customer_data ? val.customer_data.name : "",
                    trans_mode: val?.transport_mode,
                    trans_type: val?.transport_type,
                    action: (
                        <>
                            <div className="dropdown table-action">
                                <Link to="#" className="action-icon" data-bs-toggle="dropdown">
                                    <i className="fa fa-ellipsis-v"></i>
                                </Link>
                                <div className="dropdown-menu dropdown-menu-right">
                                    {/* using val.id -> because quote export info.id will mean quote id. */}
                                    <div className="dropdown-item cursor-pointer"
                                        // to={`/flexichain/job-order/add?q_id=${btoa(val.id)}`}
                                        onClick={() => { handleShow(val.id, val.ship_quotation_no, val?.customer_data ? val.customer_data.name : "", val.customer_data ? val.customer_data.id : 0, val.transport_mode, val.transport_type) }}
                                    >
                                        <i className="fa-solid fa-bolt text-blue me-1"></i> Create Job Order
                                    </div>
                                </div>
                            </div>
                        </>
                    )
                })
            });


            setDataSource(arr);
        }
    }, [loadingUnusedFinalQuotationWithPaginationList, UnusedFinalQuotationWithPaginationList]);


    useEffect(() => {
        if (UnusedFinalQuotationWithPaginationListCurrentPage) {
            setCurrentPage(UnusedFinalQuotationWithPaginationListCurrentPage);
        }


        if (UnusedFinalQuotationWithPaginationListTotalPage) {
            setTotalPages(UnusedFinalQuotationWithPaginationListTotalPage)
        }
    }, [
        UnusedFinalQuotationWithPaginationListCurrentPage,
        UnusedFinalQuotationWithPaginationListTotalPage,
        UnusedFinalQuotationWithPaginationListTotalData
    ]);




    const handlePageClick = (selectedObject) => {
        const selectedPage = selectedObject.selected + 1;
        const params = new URLSearchParams(location.search);
        setCurrentPage(selectedPage);
        params.set("page", selectedPage);
        navigate(`?${params.toString()}`);
    };


    //search functionality
    let initialValues = {
        search_text: "",
    };
    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: (values) => {
            const search_text = values.search_text.trim();
            const currentUrl = new URL(window.location.href);


            if (search_text) {
                currentUrl.searchParams.set("search", search_text);
            } else {
                currentUrl.searchParams.delete("search");
            }
            navigate(`${currentUrl.pathname}${currentUrl.search}`);
        }
    });


    useEffect(() => {
        if (queryParams.get("search")) {
            // console.log(queryParams.get("search"));
            formik.setFieldValue("search_text", queryParams.get("search"))
        }
    }, [queryParams.get("search")])


    const handleReset = () => {
        try {
            formik.setFieldValue("search_text", "");
            formik.handleSubmit();
        } catch (error) {
            console.log(error)
        }
    };


    const resetCompanyName = () => {
        setCompanyName("");
    }





    return (
        <>
            <div className="page-wrapper">
                <div className="content">
                    <div className="row">
                        <div className="col-md-12">
                            {/* Page Header */}
                            <div className="page-header">
                                <div className="row align-items-center">
                                    <div className="col-8">
                                        <h4 className="page-title">
                                            {title}<span className="count-title">{UnusedFinalQuotationWithPaginationListTotalData ?? "0"}</span>
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card">
                        <div className="card-header py-2">
                            <form onSubmit={formik.handleSubmit}>
                                <div className="row align-items-center">
                                    <div className="col-sm-4">
                                        <div className="icon-form mb-3 mb-sm-0">
                                            <span className="form-icon">
                                                <i className="ti ti-search" />
                                            </span>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                placeholder="Search Quotation No. or Customer"
                                                name='search_text'
                                                value={formik.values.search_text}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-8">


                                        <div className="d-flex align-items-center flex-wrap row-gap-2 justify-content-sm-end">
                                            <button type='submit' className="btn btn-primary me-2">
                                                Search
                                            </button>
                                            <button type='button' className="btn btn-primary ms-2" onClick={handleReset}>
                                                Reset
                                            </button>


                                            {/* {accessedPermission.includes("add_quote_request_form") && (user_id == 2) && <div
                                                className="btn btn-primary cursor-pointer"
                                                onClick={handleOpenAdd}
                                            >
                                                <i className="ti ti-square-rounded-plus me-2" />
                                                Add Country
                                            </div>} */}
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>


                        <div className="card-body py-2">
                            {
                                showLoader ?
                                    <>
                                        <div className='d-flex justify-content-center align-items-center' style={{ height: "400px", width: "100%" }}>
                                            <Beatloader />
                                        </div>
                                    </> :
                                    <>
                                        <div className="table-responsive custom-table">
                                            <Table className="table datanew dataTable no-footer" pagination={false}
                                                dataSource={dataSource} columns={columns} />
                                        </div>
                                        <div className="row align-items-center">
                                            {dataSource.length ? <div className="pagination-controls my-5 d-flex justify-content-center align-items-center react-custom-paginate">
                                                <ReactPaginate
                                                    previousLabel={<img src="/img/right.png" alt="Previous" />}
                                                    nextLabel={<img src="/img/left.png" alt="Next" />}
                                                    breakLabel="..."
                                                    breakClassName="break-me"
                                                    pageCount={totalPages}
                                                    marginPagesDisplayed={2}
                                                    pageRangeDisplayed={5}
                                                    onPageChange={handlePageClick}
                                                    containerClassName="pagination"
                                                    activeClassName="active"
                                                    forcePage={currentPage - 1}
                                                />
                                            </div> :
                                                null
                                            }
                                        </div>
                                    </>
                            }
                        </div>
                    </div>
                </div>
            </div>

            <AddJobOrderByQuotationOffcanvas3
                token={token}
                user_id={user_id}
                show={show}
                handleClose={handleClose}
                quotation_id={quotation_id}
                quotation_no={quotation_no}
                companyName={companyName}
                company_id={company_id}
                trans_mode={trans_mode}
                trans_type={trans_type}
            />
        </>



        ///Open Job order offCanvas



    )
}

export default FinalQuotationList